<template>
  <div id="footer" class="font-12 py-2">
    <v-spacer />

    <v-icon style="font-size: 20px">mdi-cart</v-icon>
    <span class="ml-1">Acessar Tela de Compras</span>

    <v-divider vertical class="mx-3" />

    <v-icon style="font-size: 20px" color="orange">mdi-cart-remove</v-icon>
    <span class="ml-1">Produto inativo para venda</span>

    <v-divider vertical class="mx-3" />

    <v-icon style="font-size: 20px" color="error">mdi-alert</v-icon>
    <span class="ml-1">Produto Fora de Linha</span>

    <v-divider vertical class="mx-3" />

    <span>Itens carregados: {{countItems}}</span>
  </div>
</template>

<script>
export default {
  name: "FooterDataTable",
  props: {
    countItems: Number
  }
}
</script>

<style scoped>
#footer {
  display: flex;
  align-items: center;
  width: 100%;
}
.bloco {
  height: 15px;
  width: 15px;
}
</style>
